export default "__VITE_ASSET__BtHkF0yC__"